<template>
  <div></div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  computed: {
    url() {
      return this.$route.query.url;
    }
  },
  mounted() {
    this.showIFrame();
  },
  activated() {
    this.showIFrame();
  },
  deactivated() {
    this.setIsShowIFrame(false);
  },
  watch: {
    url: {
      handler(val) {
        if (val) {
          this.showIFrame();
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.setIsShowIFrame(false);
    next();
  },
  methods: {
    ...mapActions(["setIsShowIFrame", "pushIFrameUrl"]),
    showIFrame() {
      this.setIsShowIFrame(true);
      this.pushIFrameUrl(this.url);
    }
  }
};
</script>
